import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'info', 
  showActions = false,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmDisabled = false,
  confirmLoading = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#22c55e' }} />;
      case 'error':
        return <FontAwesomeIcon icon={faTimesCircle} style={{ color: '#ef4444' }} />;
      case 'warning':
        return <FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f59e0b' }} />;
      default:
        return <FontAwesomeIcon icon={faInfoCircle} style={{ color: '#3b82f6' }} />;
    }
  };

  
  

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        margin: '16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{ marginRight: '12px', fontSize: '20px' }}>
            {getIcon()}
          </div>
          <h3 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#111827',
            margin: 0
          }}>
            {title || 'Notification'}
          </h3>
        </div>
        
        <div style={{ marginBottom: '24px' }}>
          <p style={{ color: '#374151', margin: 0, lineHeight: '1.5' }}>{message}</p>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          {showActions ? (
            <>
              <button
                onClick={onCancel || onClose}
                style={{
                  padding: '8px 16px',
                  borderRadius: '6px',
                  border: '1px solid #d1d5db',
                  backgroundColor: 'white',
                  color: '#374151',
                  fontWeight: '500',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                {cancelText}
              </button>
              <button
                onClick={onConfirm}
                disabled={confirmDisabled}
                style={{
                  padding: '8px 16px',
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: type === 'warning' ? '#dc2626' : '#2563eb',
                  color: 'white',
                  fontWeight: '500',
                  cursor: confirmDisabled ? 'not-allowed' : 'pointer',
                  opacity: confirmDisabled ? 0.5 : 1,
                  fontSize: '14px'
                }}
              >
                {confirmLoading ? 'Loading...' : confirmText}
              </button>
            </>
          ) : (
            <button
              onClick={onClose}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: type === 'warning' ? '#dc2626' : '#2563eb',
                color: 'white',
                fontWeight: '500',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;